import { RENTAL_TYPE_TRANSLATIONS_MAPPING, FILTERS_TO_SEO_TERMS_MAPPING } from './seoMultilingualTerms';
import { describeFilters } from '../describeFilters';
import { getSearchQueryMetadata } from '@spa/shared/utils/searchQuery';
import LANGUAGES from '@spa/shared/constants/languages';

const { ES, FR, IT, PT, DE, PL } = LANGUAGES;

export const buildTitle = ({ t, language, detailedLocation, searchQuery }) => {
  const hasLocaleSEOTerms = !!RENTAL_TYPE_TRANSLATIONS_MAPPING[language];
  const seoTermsObjectMapped = FILTERS_TO_SEO_TERMS_MAPPING.find(({ assert }) => assert({ searchQuery }));
  const shouldBuildTitleWithSEOTerms = hasLocaleSEOTerms && !!seoTermsObjectMapped;

  if (shouldBuildTitleWithSEOTerms) {
    return seoTermsObjectMapped.buildSEOTitle({ t, language, detailedLocation, searchQuery });
  }

  return convertFiltersToTitle({ t, language, detailedLocation, searchQuery });
};

const convertFiltersToTitle = ({ t, language, detailedLocation, searchQuery }) => {
  const filtersDescriptionAssember = FILTERS_DESCRIPTION_ASSEMBLERS_MAPPING.find(({ assert }) => assert({ language }));
  const filtersDescription = filtersDescriptionAssember
    .assemble({ t, language, searchQuery })
    .replace(/\s+/g, ' ')
    .trim();

  const { rentTypesAndStudentResidenceCount } = getSearchQueryMetadata(searchQuery);

  if (language === ES && rentTypesAndStudentResidenceCount === 0) {
    return `${filtersDescription} en Alquiler en ${detailedLocation}`;
  }

  if (language === FR && rentTypesAndStudentResidenceCount === 0) {
    return `Location de ${filtersDescription} à ${detailedLocation}`;
  }

  return t('{{filtersDescription}} for Rent in {{city}}', {
    filtersDescription,
    city: detailedLocation
  });
};

const FILTERS_DESCRIPTION_ASSEMBLERS_MAPPING = [
  {
    assert: ({ language }) => {
      return [ES, FR, IT, PT].includes(language);
    },
    assemble: ({ t, language, searchQuery }) => {
      const {
        rentalTypesText,
        featuresAndPetsAllowedText,
        suitableForText,
        genderExclusivityText,
        pricingSortText
      } = describeFilters({
        t,
        language,
        searchQuery
      });

      return [
        rentalTypesText,
        pricingSortText,
        featuresAndPetsAllowedText,
        genderExclusivityText,
        suitableForText
      ].join(' ');
    }
  },
  {
    assert: ({ language }) => {
      return [DE, PL].includes(language);
    },
    assemble: ({ t, language, searchQuery }) => {
      const {
        rentalTypesText,
        featuresAndPetsAllowedText,
        suitableForText,
        genderExclusivityText,
        pricingSortText
      } = describeFilters({
        t,
        language,
        searchQuery
      });

      return [
        pricingSortText,
        rentalTypesText,
        featuresAndPetsAllowedText,
        genderExclusivityText,
        suitableForText
      ].join(' ');
    }
  },
  {
    assert: ({ language }) => {
      return !!language;
    },
    assemble: ({ t, language, searchQuery }) => {
      const {
        rentalTypesText,
        featuresAndPetsAllowedText,
        suitableForText,
        genderExclusivityText,
        pricingSortText
      } = describeFilters({
        t,
        language,
        searchQuery
      });

      return [
        pricingSortText,
        genderExclusivityText,
        rentalTypesText,
        featuresAndPetsAllowedText,
        suitableForText
      ].join(' ');
    }
  }
];
